import axios from 'axios'

export default new class UserService {
  login (email, password) {
    const requestData = {email, password}
    return axios.post('/authenticate', requestData)
  }
}()
